"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const MenuItems = react_1.default.forwardRef((_a, ref) => {
    var { pullRight, className, children } = _a, remainingProps = tslib_1.__rest(_a, ["pullRight", "className", "children"]);
    const dropdownMenuClasses = (0, classnames_1.default)('dropdown-menu', pullRight && 'pull-right', className);
    return ((0, jsx_runtime_1.jsx)("ul", Object.assign({}, remainingProps, { className: dropdownMenuClasses, ref: ref, role: 'menu' }, { children: children })));
});
exports.default = MenuItems;
